import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
export function template() {
  var _a, _b;

  return jsx("div", {
    sel: '.copy-to-clipboard-button'
  }, jsx(ButtonEl, {
    attrs: {
      icon: "duplicate",
      theme: (_a = this.attr("theme")) !== null && _a !== void 0 ? _a : ButtonTheme.Tertiary,
      size: (_b = this.attr("size")) !== null && _b !== void 0 ? _b : ButtonSize.Large
    },
    on: {
      click: this.helpers.copyValue
    }
  }, this.innerHTML.trim() && jsx("slot", null)), jsx(TooltipEl, {
    attrs: {
      'max-width': "64px",
      text: "Copy"
    }
  }));
}